import createCache from '@emotion/cache';

export const defaultEmotionCache = createCache({
    key: 'mr',
    prepend: true
  }
);